const getOrderNumber = (invoice) => {
    if(invoice.attributes.type == 'Invoice' && (invoice.attributes.customerPO || invoice.attributes.poCode)) {
        const poCode = invoice.attributes.customerPO || invoice.attributes.poCode;
        if (!poCode.startsWith('IO')) {
            return '-';
        }
        return '10000' + poCode.replace('IO', '');
    }
    return '-';
}

export default getOrderNumber;